var map = {
	"./contact.vue": [
		9161,
		161
	],
	"./contactPhrase.vue": [
		9823,
		823
	],
	"./html.vue": [
		1511,
		511
	],
	"./landingCards.vue": [
		2111
	],
	"./nullData.vue": [
		5669
	],
	"./plans.vue": [
		6439,
		439
	],
	"./pricing.vue": [
		7340
	],
	"./resings.vue": [
		7867,
		867
	],
	"./whatsapp.vue": [
		9318
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2043;
module.exports = webpackAsyncContext;